import { waitForElm } from './addAccessibility';

export const formatAdminMessages = (allMessages, otherUserInfo, accountType) => {
  const adminMsgs = allMessages.filter((msg) => msg.messageType === 'admin');

  adminMsgs?.forEach((msg) => {
    // sendbird refreshes the channel when idle for a few minutes
    // custom data added via graphql does not persist so saving it to session storage
    let storedMsgData = JSON.parse(sessionStorage.getItem(msg.messageId));

    if (!storedMsgData) {
      sessionStorage.setItem(msg.messageId, JSON.stringify(msg.metaArrays));
      storedMsgData = JSON.parse(sessionStorage.getItem(msg.messageId));
    }

    const getValue = (key) => storedMsgData?.find((item) => item.key === key)?.value?.toString();
    const otherUserName = otherUserInfo?.name;
    let newHTML;

    // Parent
    if (accountType === 'parent' && getValue('interview_request_id') && getValue('interview_request_kind') !== null) {
      const interviewId = getValue('interview_request_id');
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You created a <a class="sendbird-admin-message__link" href="/requests/${interviewId}" target="_blank">booking request</a></span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You created a <a class="sendbird-admin-message__link" href="/requests/${interviewId}" target="_blank">interview request</a></span>`;
      }
    }

    if (accountType === 'parent' && getValue('interview_contract_id') && getValue('interview_contract_kind') !== null) {
      const contractId = getValue('interview_contract_id');
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} accepted your <a class="sendbird-admin-message__link" href="/bookings/${contractId}" target="_blank">booking request</a></span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} accepted your <a class="sendbird-admin-message__link" href="/bookings/${contractId}" target="_blank">interview request</a></span>`;
      }
    }

    if (accountType === 'parent' && getValue('job_application_uuid')) {
      const jobUuid = getValue('job_uuid');
      const jobAppUuid = getValue('job_application_uuid');
      newHTML = `<span class="custom-admin-text">You replied to ${otherUserName}'s <a class="sendbird-admin-message__link" href="/jobs/${jobUuid}/applications/${jobAppUuid}" target="_blank">job application</a></span>`;
    }

    if (accountType === 'parent' && getValue('interview_declined_id') && getValue('interview_request_kind') !== null) {
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} declined your booking request</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} declined your interview request</span>`;
      }
    }

    if (accountType === 'parent' && getValue('interview_canceled_id') && getValue('interview_request_kind') !== null) {
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You cancelled the booking request</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You cancelled the interview request</span>`;
      }
    }

    if (accountType === 'parent' && getValue('parent_contract_cancelation_id') && getValue('interview_contract_kind') !== null) {
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You cancelled the booking</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You cancelled the interview</span>`;
      }
    }

    if (accountType === 'parent' && getValue('sitter_contract_cancelation_id') && getValue('interview_contract_kind') !== null) {
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the booking</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the interview</span>`;
      }
    }
    // Sitter

    if (accountType === 'sitter' && getValue('job_application_uuid')) {
      const jobId = getValue('job_id');
      newHTML = `<span class="custom-admin-text">${otherUserName} replied to your <a class="sendbird-admin-message__link" href="/direct_jobs/${jobId}" target="_blank">job application</a></span>`;
    }

    if (accountType === 'sitter' && getValue('interview_request_id') && getValue('interview_request_kind') !== null) {
      const interviewId = getValue('interview_request_id');
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} requested a <a class="sendbird-admin-message__link" href="/requests/${interviewId}" target="_blank">booking</a> with you</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} requested an <a class="sendbird-admin-message__link" href="/requests/${interviewId}" target="_blank">interview</a> with you</span>`;
      }
    }

    if (accountType === 'sitter' && getValue('interview_contract_id') && getValue('interview_contract_kind') !== null) {
      const contractId = getValue('interview_contract_id');
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You accepted ${otherUserName}'s <a class="sendbird-admin-message__link" href="/provider/bookings/${contractId}" target="_blank">booking request</a></span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You accepted ${otherUserName}'s <a class="sendbird-admin-message__link" href="/provider/bookings/${contractId}" target="_blank">interview request</a></span>`;
      }
    }

    if (accountType === 'sitter' && getValue('interview_declined_id') && getValue('interview_request_kind') !== null) {
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You declined ${otherUserName}'s booking request</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You declined ${otherUserName}'s interview request</span>`;
      }
    }

    if (accountType === 'sitter' && getValue('interview_canceled_id') && getValue('interview_request_kind') !== null) {
      if (getValue('interview_request_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the booking request</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the interview request</span>`;
      }
    }

    if (accountType === 'sitter' && getValue('parent_contract_cancelation_id') && getValue('interview_contract_kind') !== null) {
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the booking</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">${otherUserName} cancelled the interview</span>`;
      }
    }

    if (accountType === 'sitter' && getValue('sitter_contract_cancelation_id') && getValue('interview_contract_kind') !== null) {
      if (getValue('interview_contract_kind') === 'booking') {
        newHTML = `<span class="custom-admin-text">You cancelled the booking</span>`;
      } else {
        newHTML = `<span class="custom-admin-text">You cancelled the interview</span>`;
      }
    }

    // Job Recruit Admin Messages
    if (accountType === 'parent' && getValue('job_state') && getValue('job_state') === 'shared') {
      const jobId = getValue('job_uuid');
      newHTML = `<span class="custom-admin-text">You shared <a class="sendbird-admin-message__link" href="/direct_jobs/${jobId}" target="_blank">this job</a> with ${otherUserName}</span>`;
    }

    if (accountType === 'sitter' && getValue('job_state') && getValue('job_state') === 'shared') {
      const jobId = getValue('job_uuid');
      newHTML = `<span class="custom-admin-text">${otherUserName} shared <a class="sendbird-admin-message__link" href="/direct_jobs/${jobId}" target="_blank">their job</a></span>`;
    }

    waitForElm(`div[data-sb-message-id="${msg.messageId}"]`).then(() => {
      const adminMsgElement = document.querySelector(`[data-sb-message-id="${msg.messageId}"] .sendbird-admin-message__text`);
      const customMsg = adminMsgElement?.querySelector('.custom-admin-text');

      if (!!adminMsgElement && !customMsg) {
        adminMsgElement.innerHTML = newHTML;
      }
    });
  });
};

export default formatAdminMessages;
